<script setup>
import { inject, onMounted } from 'vue';
import { CdrText, CdrButton } from '@rei/cedar';
import cms from './data';
import { removeBeforeUnload } from '../../common/elements-helper';

const metricsClick = inject('metricsClick');

const handleLinkClick = () => {
  metricsClick('CancellationSuccess', 'back to home');
};

onMounted(() => {
  removeBeforeUnload();
});
</script>

<template>
  <section class="cancellation-success">
    <CdrText
      class="cancellation-success__title"
      tag="h1"
    >
      {{ cms.cancellationSuccess.title }}
    </CdrText>
    <div>
      <CdrText
        class="cancellation-success__sub-title"
        tag="h2"
      >
        {{ cms.cancellationSuccess.subTitle }}
      </CdrText>
      <CdrText class="cancellation-success__body">{{ cms.cancellationSuccess.body }}</CdrText>
    </div>
    <CdrButton
      tag="a"
      modifier="secondary"
      size="large"
      :href="cms.cancellationSuccess.link.href"
      data-analytics-id="day-cancellation:CancellationSuccess_back to events home"
      @click="handleLinkClick"
    >
      {{ cms.cancellationSuccess.link.name }}
    </CdrButton>
  </section>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.cancellation-success {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: $cdr-space-two-x;

  &__title {
    @include cdr-text-heading-serif-900;
  }

  &__sub-title {
    @include cdr-text-heading-serif-500;
    color: $cdr-color-text-brand;
  }

  &__body {
    @include cdr-text-body-300;
    max-width: 540px;
    padding-top: $cdr-space-one-x;
  }
}
</style>
